import {
  CONTRATO_DOC_URL,
  TERMINOS_CONDICIONES_DOC_URL,
  AVISO_PRIVACIDAD_DOC_URL,
} from '@/utilidades/utilidades'

const state = {
  guias: [
    {
      id: 'verificacion-otp',
      paso: [
        {
          id: 'activaCash',
          numero: 2,
        },
        {
          id: 'enlazaMas',
          numero: 1,
        },
      ],
      descripcionPaso: 'Validación SMS',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          En este paso es necesario validar tu número celular, esto con el
          propósito de dar más seguridad al proceso y verificar que quien realiza el
          proceso eres tú.
        </p>
        <p>
          Te hemos enviado un código de verificación de seis dígitos vía SMS, si no lo
          recibiste da click en el botón de REENVIAR.
        </p>
        <p>
          El código cuenta con una vigencia de tiempo, por lo que si has introducido un código
          caducado da click en el botón REENVIAR para recibir un nuevo código.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/bienvenida',
        },
        {
          id: 'enlazaMas',
          valor: '/bienvenida',
        },
      ],
    },
    {
      id: 'parametrizacion',
      paso: [
        {
          id: 'activaCash',
          numero: 1,
        },
        {
          id: 'enlazaMas',
          numero: 2,
        },
      ],
      descripcionPaso: 'Parametriza tu oferta de crédito',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          En este paso puedes visualizar el monto autorizado que tienes disponible, 
          así como elegir cada cuándo quieres realizar tus pagos y plazo que más 
          se ajuste a tus necesidades. En esta pantalla también verás la vigencia de la oferta y la tasa mensual.
        </p>
        <p>
          Para ajustar el monto a tus necesidades, puedes escribirlo directamente en
          la sección con la leyenda ¿Cuánto dinero necesitas?. También puedes utilizar
          el slider (línea verde debajo del monto) y deslizar hacia la izquierda o derecha
          para reducir o aumentar el monto deseado.
        </p>
        <p>
          <b>Ten en cuenta que el monto elegido debe cumplir con las siguientes características</b>
          <ol>
            <li>Monto mínimo de $5,000.00 pesos</li>
            <li>Elejir cantidades múltiplos de 100</li>
          </ol>
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/verificacion-otp',
        },
        {
          id: 'enlazaMas',
          valor: '/verificacion-otp',
        },
      ],
    },
    {
      id: 'actualizaMonto',
      paso: [
        {
          id: 'activaCash',
          numero: -1,
        },
        {
          id: 'enlazaMas',
          numero: -1,
        },
      ],
      descripcionPaso: 'Actualiza el monto de tu crédito',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          En este paso puedes visualizar el monto autorizado que tienes disponible, 
          así como elegir cada cuándo quieres realizar tus pagos y plazo que más 
          se ajuste a tus necesidades. En esta pantalla también verás la vigencia de la oferta y la tasa mensual.
        </p>
        <p>
          Para ajustar el monto a tus necesidades, puedes escribirlo directamente en
          la sección con la leyenda ¿Cuánto dinero necesitas?. También puedes utilizar
          el slider (línea verde debajo del monto) y deslizar hacia la izquierda o derecha
          para reducir o aumentar el monto deseado.
        </p>
        <p>
          <b>Ten en cuenta que el monto elegido debe cumplir con las siguientes características</b>
          <ol>
            <li>Monto mínimo de $5,000.00 pesos</li>
            <li>Elejir cantidades múltiplos de 100</li>
          </ol>
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: null,
        },
        {
          id: 'enlazaMas',
          valor: null,
        },
      ],
    },
    {
      id: 'parametrizacion-editar',
      paso: [
        {
          id: 'activaCash',
          numero: 6,
        },
        {
          id: 'enlazaMas',
          numero: 6,
        },
      ],
      descripcionPaso: 'Edita tu solicitud de crédito',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          En este paso puedes visualizar las características del crédito que configuraste
          hace un monto, si deseas puedes editarlo, en caso contrario has click en el botón CONFIRMAR. 
        </p>
        <p>
          En esta pantalla también verás la vigencia de la oferta y la tasa mensual.
        </p>
        <p>
          Para ajustar el monto a tus necesidades, puedes escribirlo directamente en
          la sección con la leyenda ¿Cuánto dinero necesitas?. También puedes utilizar
          el slider (línea verde debajo del monto) y deslizar hacia la izquierda o derecha
          para reducir o aumentar el monto deseado.
        </p>
        <p>
          <b>Ten en cuenta que el monto elegido debe cumplir con las siguientes características</b>
          <ol>
            <li>Monto mínimo de $5,000.00 pesos mexicanos</li>
            <li>Ser un monto múltipo de 100</li>
          </ol>
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: false,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/confirmacion',
        },
        {
          id: 'enlazaMas',
          valor: '/confirmacion',
        },
      ],
    },
    {
      id: 'cargaDocumentos',
      paso: [
        {
          id: 'activaCash',
          numero: 4,
        },
        {
          id: 'enlazaMas',
          numero: 4,
        },
      ],
      descripcionPaso: 'Carga de documentos',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          Deberás tomar las fotografías indicadas a continuación. La imagen deberá cumplir con los requisitos descritos. Para comenzar has click
          en el botón de cámara ubicado al final de la página.
        </p>
        <p>
          ¿Por qué son necesarias estas fotografías? Porque agregan seguridad al proceso y sirven con el fin de comprobar tu identidad. Asegúrate que la imagen sea clara.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/parametrizacion',
        },
        {
          id: 'enlazaMas',
          valor: '/datosDomicilio',
        },
      ],
    },
    {
      id: 'actualizaDocumentos',
      paso: [
        {
          id: 'activaCash',
          numero: -2,
        },
        {
          id: 'enlazaMas',
          numero: -2,
        },
      ],
      descripcionPaso: 'Actualiza tus documentos',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Deberás tomar una fotografías para comprobar tu identidad. La imagen deberá cumplir con los requisitos descritos. Para comenzar has click
          en el botón de cámara.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: false,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: null,
        },
        {
          id: 'enlazaMas',
          valor: null,
        },
      ],
    },
    {
      id: 'correo',
      paso: [
        {
          id: 'activaCash',
          numero: 5,
        },
        {
          id: 'enlazaMas',
          numero: 5,
        },
      ],
      descripcionPaso: 'Ingresa tu correo electrónico',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          En este paso deberás ingresar tu correo electrónico. <b>Es muy importante que ingreses un correo electrónico al que puedas inciar sesión</b>, 
          ya que por este medio recibirás tus contratos y los siguientes pasos a realizar en caso de ser aprobado tu crédito.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/cargaDocumentos',
        },
        {
          id: 'enlazaMas',
          valor: '/cargaDocumentos',
        },
      ],
    },
    {
      id: 'contrasena',
      paso: [
        {
          id: 'activaCash',
          numero: 6,
        },
        {
          id: 'enlazaMas',
          numero: 6,
        },
      ],
      descripcionPaso: 'Ingresa tu contraseña para CMV Finanzas',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          En este paso vas a establecer la contraseña con la que ingresarás a la app de <b>CMV Finanzas</b>,
          la cual es la aplicación de <b>banca en línea</b> de Valladolid Caja Financiera
        </p>
        <p>
          Te recomendamos <b>ingresar una contraseña segura</b> que cumpla con los requisitos descritos.
        </p>
        <p>
          Una vez aprobado tu crédito, el dinero será depositado en tu cuenta <b>INVERDINAMICA</b> la cual podrás 
          administrar desde la app de CMV Finanzas.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/correo',
        },
        {
          id: 'enlazaMas',
          valor: '/correo',
        },
      ],
    },
    {
      id: 'confirmacion',
      paso: [
        {
          id: 'activaCash',
          numero: 7,
        },
        {
          id: 'enlazaMas',
          numero: 7,
        },
      ],
      descripcionPaso: 'Confirma tu crédito',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          Revisa que los datos de tu crédito correspondan al producto que deseas adquirir, si son correctos, da click en CONFIRMAR, en caso
          contrario puedes volver a editar la información al hacer click en el botón de EDITAR.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/contrasena',
        },
        {
          id: 'enlazaMas',
          valor: '/contrasena',
        },
      ],
    },
    {
      id: 'aceptacion-contratos',
      paso: [
        {
          id: 'activaCash',
          numero: 8,
        },
        {
          id: 'enlazaMas',
          numero: 8,
        },
      ],
      descripcionPaso: 'Firma de contratos',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          Sólo falta que leas detenidamente los contratos y aceptes el estar de acuerdo con ellos.
        </p>
        <p>
          Te hemos enviado un código de verificación de seis dígitos vía SMS, si no lo
          recibiste da click en el botón de REENVIAR.
        </p>
        <p>
          El código cuenta con una vigencia de tiempo, por lo que si has introducido un código
          caducado da click en el botón REENVIAR para recibir un nuevo código.
        </p>
        <p>
          Para aceptar los contratos y poder finalizar tu proceso marca la casilla con la leyenda: <b>Despúes de haber leído los términos del contrato y pagaré, expreso mi consentimiento al estar de acuerdo con ellos.</b>
          <b>No podrás aceptar la casilla si no ingresar antes un código de verificación válido.</b>
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/confirmacion',
        },
        {
          id: 'enlazaMas',
          valor: '/confirmacion',
        },
      ],
    },
    {
      id: 'terminacion',
      paso: [
        {
          id: 'activaCash',
          numero: 10,
        },
        {
          id: 'enlazaMas',
          numero: 9,
        },
      ],
      descripcionPaso: 'Terminaste',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          <b>¡Has columinado tu proceso de solicitud con éxito!</b>
        </p>
        <p>
          Espera recibir un mensaje SMS con una respuesta a tu solicitud.
        </p>  
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: false,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/aceptacion-contratos',
        },
        {
          id: 'enlazaMas',
          valor: '/aceptacion-contratos',
        },
      ],
    },
    {
      id: 'terminacionActualizacion',
      paso: [
        {
          id: 'activaCash',
          numero: -3,
        },
        {
          id: 'enlazaMas',
          numero: -3,
        },
      ],
      descripcionPaso: 'Termino mi actualización de devolución',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Hay varias opciones para que puedas disponer de tu dinero una vez haya sido depositado en tu cuenta <b>INVERDINAMICA:</b>
        </p>
        <p>
          <ol>
            <li>Descarga la aplicacion de CMV Finanzas o ingresa a la <a target="_blank" href="https://cmvfinanzas.cajamorelia.com.mx/">Página de CMV Finanzas</a> y con la contraseña que ya generaste registrate y podrás transferir el dinero a otras cuentas.</li>
            <li>Acude a la línea de cajas de tu sucursal más cercana para hacer un retiro de tu cuenta INVERDINAMICA</li>
          </ol>
        </p>  
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: false,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/aceptacion-contratos',
        },
        {
          id: 'enlazaMas',
          valor: '/aceptacion-contratos',
        },
      ],
    },
    {
      id: 'confirmacion-buro',
      paso: [
        {
          id: 'activaCash',
          numero: 2,
        },
        {
          id: 'enlazaMas',
          numero: 1,
        },
      ],
      descripcionPaso: 'Revisión de buró de crédito',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          Con base en tu historial crediticio, es posible que el monto de tu
          crédito se haya ajustado. Aquí puedes revisar el nuevo monto y decidir
          si deseas continuar o modificar tu solicitud.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: false,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: null,
        },
        {
          id: 'enlazaMas',
          valor: null,
        },
      ],
    },
    {
      id: 'rechazo-solicitud',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Resultado de tu solicitud',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Hemos revisado tu solicitud de crédito y por el momento no es
          posible continuar con el proceso.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: false,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: null,
        },
        {
          id: 'enlazaMas',
          valor: null,
        },
      ],
    },
    {
      id: 'editar-monto-buro',
      paso: [
        {
          id: 'activaCash',
          numero: 2,
        },
        {
          id: 'enlazaMas',
          numero: 1,
        },
      ],
      descripcionPaso: 'Ajusta el monto de tu crédito',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          Con base en el resultado de tu buró de crédito, puedes ajustar el
          monto, la frecuencia y el plazo de tu crédito antes de continuar.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: false,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: null,
        },
        {
          id: 'enlazaMas',
          valor: null,
        },
      ],
    },
    {
      id: 'contrato',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Contratos',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Este es el documento de Contratos que aceptas si marcas la casilla con la leyenda <b>Acepto firmar digitalmente los contratos del crédito</b>.
        </p>
        <p>
          <b>Lee detenidamente el documento y guárdalo para cualquier duda y/o aclaración.</b>
        </p>
        <p>
          Para descargar el documento has click en el botón ubicado arriba a la derecha.
        </p>
      `,
      esVisibleBtnDescargar: true,
      urlDocumento: './' + CONTRATO_DOC_URL,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/aceptacion-contratos',
        },
        {
          id: 'enlazaMas',
          valor: '/aceptacion-contratos',
        },
      ],
    },
    {
      id: 'terminos-y-condiciones',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Términos y Condiciones',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Este es el documento de Términos y Condiciones que aceptas si decides continuar con el proceso. <b>Lee detenidamente el documento y guárdalo para cualquier duda y/o aclaración.</b>
        </p>
        <p>
          Para descargar el documento has click en el botón ubicado arriba a la derecha.
        </p>
      `,
      esVisibleBtnDescargar: true,
      urlDocumento: './' + TERMINOS_CONDICIONES_DOC_URL,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/verificacion-otp',
        },
        {
          id: 'enlazaMas',
          valor: '/verificacion-otp',
        },
      ],
    },
    {
      id: 'aviso-de-privacidad',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Aviso de Privacidad',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Este es el documento Aviso de Privacidad que aceptas si decides continuar con el proceso. <b>Lee detenidamente el documento y guárdalo para cualquier duda y/o aclaración.</b>
        </p>
        <p>
          Para descargar el documento has click en el botón ubicado arriba a la derecha.
        </p>
      `,
      esVisibleBtnDescargar: true,
      urlDocumento: './' + AVISO_PRIVACIDAD_DOC_URL,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/verificacion-otp',
        },
        {
          id: 'enlazaMas',
          valor: '/verificacion-otp',
        },
      ],
    },
    {
      id: 'cancelacion',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Cancelación',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Bajo esta acción estás confirmando que no deseas continuar con el proceso de solicitud de crédito, pero deseamos conocer la razón por la cual cancelas esta oportunidad.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/bienvenida',
        },
        {
          id: 'enlazaMas',
          valor: '/bienvenida',
        },
      ],
    },
    {
      id: 'comprobante',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Comprobante',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Este es tu comprobante, consérvalo para cualquier duda y/o aclaración.
        </p>
      `,
      esVisibleBtnDescargar: true,
      urlDocumento: './docs/Comprobante.pdf',
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/terminacion',
        },
        {
          id: 'enlazaMas',
          valor: '/terminacion',
        },
      ],
    },
    {
      id: 'beneficios',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: 3,
        },
      ],
      descripcionPaso: 'Hazte socio',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          Para poder adquirir la oferta de crédito necesitamos que te hagas socio de nuestra cooperativa, haz click en ¡QUIERO SER SOCIO! para empezar el proceso.
        </p>
        <p>
          Para hacerte socio se requiere la aportación social de $500 los cuales serán financiados con tu crédito para que no los tengas que pagar ahora.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: null,
        },
        {
          id: 'enlazaMas',
          valor: '/parametrizacion',
        },
      ],
    },
    {
      id: 'datosPersonales',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: 3,
        },
      ],
      descripcionPaso: 'Ingresa tus datos personales',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          Necesitamos que confirmes que tenemos tus datos correctos para poder darte de alta como socio de nuestra cooperativa.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: null,
        },
        {
          id: 'enlazaMas',
          valor: '/beneficios',
        },
      ],
    },
    {
      id: 'datosDomicilio',
      paso: [
        {
          id: 'activaCash',
          numero: 3,
        },
        {
          id: 'enlazaMas',
          numero: 3,
        },
      ],
      descripcionPaso: 'Confirma tu domicilio',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          Necesitamos que confirmes tu domicilio donde resides actualmente paratener la información de contacto actualizada.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: null,
        },
        {
          id: 'enlazaMas',
          valor: '/datosPersonales',
        },
      ],
    },
    {
      id: 'terminos-buro',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Términos de Buró de Crédito',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Lee detenidamente los términos de Buró de Crédito, los cuales aceptas si deseas continuar con el proceso
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/verificacion-otp',
        },
        {
          id: 'enlazaMas',
          valor: '/verificacion-otp',
        },
      ],
    },
    {
      id: 'confirmar-terminos-buro',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Términos de Buró de Crédito',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Lee detenidamente los términos de Buró de Crédito, los cuales aceptas si deseas continuar con el proceso
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: true,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/aceptacion-contratos',
        },
        {
          id: 'enlazaMas',
          valor: '/aceptacion-contratos',
        },
      ],
    },
    {
      id: 'avanceCredito',
      paso: [
        {
          id: 'activaCash',
          numero: null,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Estatus de tu solicitud de crédito',
      esProgresoVisible: false,
      contenidoGuia: `
        <p>
          Esta pantalla te da la información del estatus actual de tu solicitud de crédito, si aun tienes alguna duda comunicate con nosotros por medio de nuesrto whatsapp o al 01800.
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: false,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: null,
        },
        {
          id: 'enlazaMas',
          valor: null,
        },
      ],
    },
    {
      id: 'referencia',
      paso: [
        {
          id: 'activaCash',
          numero: 6,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Referencia familiar',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          Requerimos nos dejes un contacto de referencia familiar, se le llamara para validar tu identidad
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: false,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/correo',
        },
        {
          id: 'enlazaMas',
          valor: '/correo',
        },
      ],
    },
    {
      id: 'CanvasFirmaUsuario',
      paso: [
        {
          id: 'activaCash',
          numero: 9,
        },
        {
          id: 'enlazaMas',
          numero: null,
        },
      ],
      descripcionPaso: 'Firma de aceptacion de contratos',
      esProgresoVisible: true,
      contenidoGuia: `
        <p>
          Requerimos nos dejes tu firma que avala la autenticidad de tu solicitud
        </p>
      `,
      esVisibleBtnDescargar: false,
      urlDocumento: null,
      esVisibleUrlRetroceso: false,
      urlsRetroceso: [
        {
          id: 'activaCash',
          valor: '/correo',
        },
        {
          id: 'enlazaMas',
          valor: '/correo',
        },
      ],
    },
  ],
  procesos: [
    {
      id: 'activaCash',
      cantidadPasos: 9,
    },
    {
      id: 'enlazaMas',
      cantidadPasos: 8,
    },
  ],
  procesoActivo: null,
  pasoActivo: 'SeguimientoAvance',
  pasoActual: null,
}

const getters = {
  obtenerInfoGuia: (state, _, _2, rootGetters) => {
    let pasoInfo = state.guias.find((paso) => paso.id === state.pasoActivo)
    const proceso = state.procesos.find(
      (proceso) => proceso.id === state.procesoActivo
    )
    let paso = ''
    try {
      paso = pasoInfo.paso.find(
        (paso) => paso.id === state.procesoActivo
      ).numero
    } catch (e) {
      state.pasoActual = 0
      let avance = 0
      if (paso) {
        avance = Math.floor((100 / proceso.cantidadPasos) * paso)
      }
      const descripcionPasoCompleta = ''
      const pasoDetalles = {
        ...pasoInfo,
        avance,
        paso,
        descripcionPasoCompleta,
        pasoActual: state.pasoActual,
      }
      return pasoDetalles
    }
    let avance = 0
    if (paso) {
      avance = Math.floor((100 / proceso.cantidadPasos) * paso)
      state.pasoActual = paso
    }
    const descripcionPasoCompleta = paso
      ? `Paso ${paso} de ${proceso.cantidadPasos}: ${pasoInfo.descripcionPaso}`
      : pasoInfo.descripcionPaso
    let urlRetroceso = pasoInfo.urlsRetroceso.find(
      (url) => url.id === state.procesoActivo
    ).valor
    const bancaActiva = rootGetters['persona/obtenerEsBancaActiva']
    if (pasoInfo.id === 'confirmacion' && bancaActiva) {
      urlRetroceso = 'correo'
    }
    const pasoDetalles = {
      ...pasoInfo,
      avance,
      paso,
      descripcionPasoCompleta,
      urlRetroceso,
      pasoActual: state.pasoActual,
    }
    return pasoDetalles
  },
  obtenerProcesoActivo(state) {
    return state.procesoActivo
  },
  obtenerPasoActivo(state) {
    return state.pasoActivo
  },
}

const mutations = {
  establecerProcesoActivo(state, payload) {
    state.procesoActivo = payload.procesoActivo
  },
  establecerPasoActivo(state, payload) {
    state.pasoActivo = payload.pasoActivo
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
